var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgBcEth = function SvgBcEth(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 33"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bc-eth_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.635,
    r: 16,
    fill: "#627EEA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CCF7",
    d: "m15.998 7.135-.13.416v12.06l.13.122 5.998-3.309z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.998 7.135 10 16.424l5.998 3.31V7.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CCF7",
    d: "m15.996 21.554-.074.084v4.296l.074.2 6.001-7.888z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.998 26.135v-4.582L10 18.247z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8198EE",
    d: "m16 19.733 5.998-3.31L16 13.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1CCF7",
    d: "m10 16.424 5.998 3.309v-5.854z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bc-eth_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .635h32v32H0z"
  }))))));
};
export default SvgBcEth;